import { NgModule } from '@angular/core';

import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
    { path: '', loadChildren: () => import('./components/public/public.module').then(m => m.PublicModule)},
    { path: 'admin', loadChildren: () => import('./components/admin/admin.module').then(m => m.AdminModule)},
    { path: 'user', loadChildren: () => import('./components/user/user.module').then(m => m.UserModule)},
    // otherwise redirect to public
    { path: '**', redirectTo: '' }
];

@NgModule({
    imports: [ 
        RouterModule.forRoot(routes, {
            scrollPositionRestoration: 'top' // This line ensures scrolling to top
        }) 
    ],
    providers: [
        provideRouter(routes, withInMemoryScrolling({
            anchorScrolling: 'enabled',
            scrollPositionRestoration: 'enabled' // Optional: restores the scroll position when navigating back/forward
        })),   
    ],
    exports: [ RouterModule ]
})
export class AppRoutingModule {}